import { createApi } from '@reduxjs/toolkit/query/react';
import * as API from '../../apiCalls/urls/setterAdmin';
import { baseQuery } from '../../apiCalls/rtkBaseQuery';

export const setterAdminApi = createApi({
    baseQuery,
    reducerPath: 'setterAdminApi',
    tagTypes: ['setter', 'syllabus', 'Paper', 'question', 'profile', 'certificate', 'mapping', 'Issues', 'dashboard', 'filters'],
    endpoints: (builder) => ({
        getSetterList: builder.query({
            query: ({ page = 1, items = 10, filters }) => ({
                url: `${API.SETTER_LIST}?page=${page}&items=${items}`,
                method: 'POST',
                body: filters
            }),
            providesTags: ['setter'],
        }),
        getPaperList: builder.query({
            query: ({ page = 1, items = 10, filters }) => ({
                url: `${API.PAPER_LIST}?page=${page}&items=${items}`,
                method: 'POST',
                body: filters
            }),
            providesTags: ['Paper'],
        }),

        getPaperDetails: builder.query({
            query: (paperId) => ({
                url: `${API.PAPER_DETAILS}/${paperId}`,
                method: 'GET',
            }),
            providesTags: ['Paper'],
        }),

        getSetterPaperList: builder.query({
            query: ({ page = 1, items = 10, filters }) => ({
                url: `${API.SETTER_PAPER_LIST}?page=${page}&items=${items}`,
                method: 'POST',
                body: filters
            }),
            invalidatesTags: ['Paper'],
        }),

        // getSetterPaperDetails: builder.query({
        //     query: (paperId) => ({
        //         url: `${API.SETTER_PAPER_DETAILS}/${paperId}`,
        //         method: 'GET',
        //     }),
        //     providesTags: ['Paper'],
        // }),

        updatePaper: builder.mutation({
            query: ({ paperId, data }) => ({
                url: API.UPDATE_PAPER,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            }),
            invalidatesTags: ['Paper'],
        }),

        getSetterPaperMapping: builder.query({
            query: (paperId) => ({
                url: `${API.SETTER_PAPER_MAPPING}/${paperId}`,
                method: 'GET',
            }),
            providesTags: ['mapping'],
        }),

        getSetterDashboard: builder.query({
            query: (data) => ({
                url: API.SETTER_DASHBOARD,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['syllabus', 'Paper', 'mapping'],
        }),

        updateSetter: builder.mutation({
            query: (data) => ({
                url: API.UPDATE_SETTER,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['setter'],
        }),

        getPaperDetailsBySetterPaperId: builder.query({
            query: ({ setterPaperId }) => ({
                url: `${API.GET_SETTER_PAPER_DETAILS}/${setterPaperId}`,
                method: 'GET',
            }),
            providesTags: ['details'],
        }),
        getQuestionMappingByPaperId: builder.query({
            query: (paperId) => ({
                url: `${API.GET_QUESTION_MAPPING_BY_PAPER_ID}/${paperId}`,
                // url: `${API.GET_QUESTION_MAPPING_BY_PAPER_ID}${paperId}`,
                method: 'GET',
            }),
            providesTags: ['question'],
        }),
        getAllIssuesBySetterPaperId: builder.query({
            query: ({ setterPaperId, data }) => ({
                url: `${API.GET_ALL_ISSUES_BY_SETTER_PAPER_ID}/${setterPaperId}`,
                method: 'GET',
                body: data,
            }),
            providesTags: ['issues'],
        }),
        getPaperSyllabusBySetterPaperId: builder.query({
            query: ({ setterPaperId }) => ({
                url: `${API.GET_PAPER_SYLLABUS}/${setterPaperId}`,
                method: 'GET',
            }),
            providesTags: ['syllabus'],
        }),
        getSetterProfileBySetterId: builder.query({
            query: ({ id }) => ({
                url: `${API.GET_SETTER_PROFILE_BY_SETTER_ID}/${id}`,
                method: 'GET',
            }),
            providesTags: ['setterDetailsAdmin'],
        }),
        getSetterMappingBySetterId: builder.query({
            query: ({ setterId, portionId = 0, sessionId }) => ({
                url: API.GET_SETTER_MAPPING_BY_SETTER_ID + `/${setterId}?sessionId=${sessionId}&portionId=${portionId}`,
                method: 'GET',
            }),
            providesTags: ['mapping'],
        }),

        // For setter Profile CRUD
        addExperiance: builder.mutation({
            query: ({ data, cId }) => ({
                url: API.ADD_EXPERIENCE + "/" + cId,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['setterDetailsAdmin'],
        }),

        updateExperiance: builder.mutation({
            query: ({ data, cId }) => ({
                url: API.UPDATE_EXPERIENCE + "/" + cId,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['setterDetailsAdmin'],
        }),

        deleteExperiance: builder.mutation({
            query: ({ expId, cId }) => ({
                url: API.DELETE_EXPERIENCE + "/" + cId,
                method: 'DELETE',
                body: expId
            }),
            invalidatesTags: ['setterDetailsAdmin'],
        }),

        addEducation: builder.mutation({
            query: ({ data, cId }) => ({
                url: API.ADD_EDUCATION + "/" + cId,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['setterDetailsAdmin'],
        }),

        updateEducation: builder.mutation({
            query: ({ data, cId }) => ({
                url: API.UPDATE_EDUCATION + "/" + cId,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['setterDetailsAdmin'],
        }),

        deleteEducation: builder.mutation({
            query: ({ eduId, cId }) => ({
                url: API.DELETE_EDUCATION + "/" + cId,
                method: 'DELETE',
                body: eduId
            }),
            invalidatesTags: ['setterDetailsAdmin'],
        }),

        updateSetterProfile: builder.mutation({
            query: ({ preference, data, cId }) => {

                return {
                    url: API.UPDATE_PROFILE + "/" + cId,
                    method: 'POST',
                    body: !data ? { preference: preference } : data,
                }
            },
            invalidatesTags: ['setterDetailsAdmin'],
        }),

        getCertificatesLists: builder.query({
            query: (cId) => ({
                url: API.GET_CERTIFICATE_LIST + "/" + cId,
                method: 'GET',
            }),
            providesTags: ['certificate'],
        }),

        deleteCertificate: builder.mutation({
            query: ({ certiId, cId }) => ({
                url: API.DELETE_CERTIFICATE + "/" + cId,
                method: 'DELETE',
                body: certiId
            }),
            invalidatesTags: ['certificate'],
        }),

        addCertificate: builder.mutation({
            query: ({ data, cId }) => ({
                url: API.ADD_CERTIFICATE + "/" + cId,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['certificate'],
        }),
        updateCertificate: builder.mutation({
            query: ({ data, cId }) => ({
                url: API.UPDATE_CERTIFICATE + "/" + cId,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['certificate'],
        }),

        getCertificatesLink: builder.mutation({
            query: ({ formData, id }) => ({
                url: API.GET_CERTIFICATE_LINK + "/" + id,
                method: 'POST',
                body: formData
            }),
        }),
        addIntroductoryVideo: builder.mutation({
            query: ({ file, cId }) => ({
                url: API.ADD_INTRODUCTORY_VIDEO + "/" + cId,
                method: 'POST',
                body: file,
            }),
            invalidatesTags: ['setterDetailsAdmin'],
        }),
        deleteIntroductoryVideo: builder.mutation({
            query: ({ cId }) => ({
                url: API.DELETE_INTRODUCTORY_VIDEO + "/" + cId,
                method: 'DELETE',
                // body: introVId
            }),
            invalidatesTags: ['setterDetailsAdmin'],
        }),
        updateSocialLink: builder.mutation({
            query: ({ linkData, cId }) => ({
                url: API.UPDATE_SOCIAL_LINK + "/" + cId,
                method: 'POST',
                body: linkData,
            }),
            invalidatesTags: ['setterDetailsAdmin'],
        }),

        // for assigning trial paper to setter
        assignPaperToSetter: builder.mutation({
            query: (data) => ({
                url: API.ASSIGN_PAPER_TO_SETTER,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Paper'],
        }),

        // for assigning paper to setter
        assignPapersToSetter: builder.mutation({
            query: (data) => ({
                url: "/admin/users/setter/assign-papers",
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Paper', 'mapping'],
        }),
    }),
});

export const {
    useGetSetterListQuery,
    useGetPaperListQuery,
    useGetPaperDetailsQuery,
    useGetSetterPaperListQuery,
    useGetSetterPaperDetailsQuery,
    useUpdatePaperMutation,
    useGetSetterPaperMappingQuery,
    useGetSetterDashboardQuery,
    useUpdateSetterMutation,
    useGetPaperDetailsBySetterPaperIdQuery,
    useGetQuestionMappingByPaperIdQuery,
    useGetAllIssuesBySetterPaperIdQuery,
    useGetPaperSyllabusBySetterPaperIdQuery,
    useGetSetterProfileBySetterIdQuery,
    useGetSetterMappingBySetterIdQuery,

    // Hooks for Setter Profile CRUD
    useAddExperianceMutation,
    useUpdateExperianceMutation,
    useDeleteExperianceMutation,
    useAddEducationMutation,
    useUpdateEducationMutation,
    useDeleteEducationMutation,
    useUpdateSetterProfileMutation,

    // Hooks for Certificates
    useGetCertificatesListsQuery,
    useDeleteCertificateMutation,
    useAddCertificateMutation,
    useUpdateCertificateMutation,
    useGetCertificatesLinkMutation,

    // Hooks for Introductory Video
    useAddIntroductoryVideoMutation,
    useDeleteIntroductoryVideoMutation,

    // Hooks for Social Links
    useUpdateSocialLinkMutation,

    useAssignPaperToSetterMutation,
    useAssignPapersToSetterMutation

} = setterAdminApi;
